import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductResponse, ProductRoutingResponse, RoutingProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductRoutingService } from 'src/app/services/product-routing.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
    selector: 'app-product-routing',
    templateUrl: './product-routing.component.html',
    styleUrls: ['./product-routing.component.scss']
})
export class ProductRoutingComponent {
    productPricesList: ProductRoutingResponse[] = [];

    productList: any;
    productSelected: ProductRoutingResponse = null;
    productSelectedId: number = null;
    filterWord: string = null;
    timeout = null;

    pagination = {
        total: [],
        filter: [],
        pageSize: 5,
        startElement: 0,
        lastElement: 0,
        pageIndex: 0
    }
    inputs = {
        productEntry: {
            value: null,
            verified: false,
            required: false,
            message: 'Campo requerido',
            class: "fa-list",
            color: '',
            tooltip: '',
            data: { id: null }
        },
        productOutput: {
            value: null,
            verified: false,
            required: false,
            message: 'Campo requerido',
            class: "fa-list",
            color: '',
            tooltip: '',
            data: { id: null }
        },
    };

    products: ProductResponse[] = [];
    filterProductsEntry: ProductResponse[] = [];
    filterProductsOutput: ProductResponse[] = [];

    timeoutEntry = null;
    timeoutOutput = null;
    productsRouting: ProductRoutingResponse[] = [];
    filterProducts: ProductRoutingResponse[] = [];

    routingProductList: RoutingProductResponse[] = [];
    deleting: { [key: number]: boolean } = {};

    constructor(
        private productRoutingService: ProductRoutingService,
        private productService: ProductService,
        private toastService: ToastrService) { }

    ngOnInit(): void {
        this.getProducts("", this.inputs.productEntry, 'entry');
        this.getProducts("", this.inputs.productOutput, 'output');
        this.getAllRoutings();
    }

    changeInput(input, value, verified, required, classIcon, data) {
        input.value = (value !== undefined && value !== null) ? value : input.value;
        input.verified = (verified !== undefined && verified !== null) ? verified : input.verified;
        input.required = (required !== undefined && required !== null) ? required : input.required;
        input.class = (classIcon) ? classIcon : input.class;
        input.data = (data) ? data : input.data;
    }

    resetPagination() {
        this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
        this.pagination.pageIndex = 0;
        this.pagination.lastElement = this.pagination.filter.length;
        this.pagination.startElement = 0;
    }

    onInputChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.filterWord = value;
        this.searching();
    }

    searching() {
        this.pagination.total = this.productPricesList.filter((productPrice) => {
            const filter = this.filterWord.toLowerCase();

            return (
                productPrice.id + '' === this.filterWord ||
                productPrice.name.toLowerCase().includes(filter)
            );
        });

        this.pagination.pageIndex = 0;
        this.pagination.startElement = 0;
        this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
        this.pagination.lastElement = this.pagination.filter.length;
    }

    getProducts(clue: string, inputRef: any, target: 'entry' | 'output') {
        this.productService.getProducts(clue).subscribe({
            next: (response: ResponseObject) => {
                const list: ProductResponse[] = response.data || [];
                this.products = list;

                if (target === 'entry') this.filterProductsEntry = list;
                else this.filterProductsOutput = list;

                if (list.length === 0) {
                    this.changeInput(inputRef, null, false, null, 'fa-xmark', null);
                } else if (list.length === 1) {
                    this.changeInput(inputRef, list[0].name, true, null, 'fa-circle-check', list[0]);
                } else {
                    this.changeInput(inputRef, clue, false, null, 'fa-list', null);
                }
            }
        });
    }

    writeProductEntry(inputEvent: any) {
        const inputValue = inputEvent.target.value;   // <- IGUAL QUE TU EJEMPLO
        clearTimeout(this.timeoutEntry);
        this.inputs.productEntry.class = "typing";
        this.timeoutEntry = setTimeout(() => {
            this.getProducts(inputValue, this.inputs.productEntry, 'entry');
        }, 500);
    }

    writeProductOutput(inputEvent: any) {
        const inputValue = inputEvent.target.value;
        clearTimeout(this.timeoutOutput);
        this.inputs.productOutput.class = "typing";
        this.timeoutOutput = setTimeout(() => {
            this.getProducts(inputValue, this.inputs.productOutput, 'output');
        }, 500);
    }

    checkProductEntry(product: any) {
        this.changeInput(
            this.inputs.productEntry,
            product.code + " - " + product.name,
            true,
            null,
            "fa-circle-check",
            product
        );
    }

    checkProductOutput(product: any) {
        this.changeInput(
            this.inputs.productOutput,
            product.code + " - " + product.name,
            true,
            null,
            "fa-circle-check",
            product
        );
    }

    reset() {
        this.inputs.productEntry.value = null;
        this.inputs.productEntry.verified = false;
        this.inputs.productEntry.class = "fa-list";
        this.inputs.productEntry.data = { id: null };

        this.inputs.productOutput.value = null;
        this.inputs.productOutput.verified = false;
        this.inputs.productOutput.class = "fa-list";
        this.inputs.productOutput.data = { id: null };

        this.filterProductsEntry = [];
        this.filterProductsOutput = [];
    }

    getAllRoutings() {
        this.productRoutingService.getAll().subscribe({
            next: (response: ResponseObject) => {
                this.routingProductList = response.data || [];
            },
            error: (err: HttpErrorResponse) => {
                this.toastService.error(
                    err?.error?.message || 'No se pudo obtener los routings de productos',
                    'Error'
                );
                console.error(err);
            }
        });
    }

    saveRouting() {
        const payload = {
            productEntry: this.inputs.productEntry.data.id,
            productSale: this.inputs.productOutput.data.id
        };

        this.productRoutingService.create(payload).subscribe({
            next: () => {
                this.toastService.success(
                    'Routing de productos guardado correctamente',
                    'Éxito'
                );
                this.reset();
                this.getAllRoutings();
            },
            error: (err) => {
                this.toastService.error(
                    err?.error?.message || 'No se pudo guardar el routing',
                    'Error'
                );
                console.error(err);
            }
        });
    }

    deleteRouting(id: number) {
        this.productRoutingService.delete(id).subscribe({
            next: () => {
                this.toastService.success(
                    'Routing de productos eliminado correctamente',
                    'Éxito'
                );
                this.reset();
                this.getAllRoutings();
            },
            error: (err) => {
                this.toastService.error(
                    err?.error?.message || 'No se pudo eliminar el routing',
                    'Error'
                );
                console.error(err);
            }
        });
    }

}